import { FunctionComponent } from 'react'
import CooperationFeedback from '@/components/kol/common/kol-cooperation-detail-drawer/cooperation-history/cooperation-feedback'

interface CooperationHistoryProps {
  kolId: string
}

const CooperationHistory: FunctionComponent<CooperationHistoryProps> = ({
  kolId,
}) => {
  return <CooperationFeedback kolId={kolId} />
}

export default CooperationHistory
